import { useMemo } from "react";
import { CHECKLIST_DISCLAIMER_ES } from "../../../constants/buyerChecklistConstants";
import { getAllChecklistItemIds } from "../../../data/buyerChecklistContent";
import { useBuyerChecklistProgress } from "../../../hooks/useBuyerChecklistProgress";
import { useLocale } from "../../../intl";
import { getLocalizedChecklistSections } from "../../../intl/buyerChecklistCopy";
import BuyerChecklistSection from "./BuyerChecklistSection";
import ChecklistProgress from "./ChecklistProgress";
import { ChecklistPrintButton, ChecklistShareButton } from "./ChecklistActionButtons";
import "../../../styles/buyerChecklist.css";

export default function BuyerChecklistFull({
  listingId = null,
  dealerId = null,
  defaultVehicleContext = null,
  showActions = true,
  showImportance = false,
  highlightItemIds = null,
  disclaimer = null,
  actionCopy = null,
  className = "",
}) {
  const { t, exists } = useLocale();
  const sections = useMemo(() => getLocalizedChecklistSections(t, exists), [t, exists]);
  const allItemIds = useMemo(() => getAllChecklistItemIds(), []);
  const { checked, progress, toggleItem } = useBuyerChecklistProgress(listingId, allItemIds);

  return (
    <div className={`buyer-checklist-full ${className}`.trim()}>
      <div className="buyer-checklist-full__toolbar">
        <ChecklistProgress progress={progress} />
        {showActions ? (
          <div className="buyer-checklist-full__actions">
            <ChecklistPrintButton label={actionCopy?.print} />
            <ChecklistShareButton label={actionCopy?.share} />
          </div>
        ) : null}
      </div>
      <div className="buyer-checklist-full__sections">
        {sections.map((section) => (
          <BuyerChecklistSection
            key={section.id}
            section={section}
            checkedMap={checked}
            onToggle={toggleItem}
            showImportance={showImportance}
            listingId={listingId}
            dealerId={dealerId}
            defaultVehicleContext={defaultVehicleContext}
            highlightItemIds={highlightItemIds}
          />
        ))}
      </div>
      <p className="buyer-checklist-disclaimer">{disclaimer || CHECKLIST_DISCLAIMER_ES}</p>
    </div>
  );
}
